import { Controller } from "stimulus"
import { createElement, nextFrame, toSentence } from "../helpers"

export default class extends Controller {
  static targets = ["multiselect", "summary"]

  initialize() {
    this.update()
  }

  async update() {
    const { html } = this
    await nextFrame()
    this.summaryTarget.innerHTML = html
  }

  get html() {
    const { teams } = this
    if (!teams.length)
      return `
        Select a team to continue.
      `
    if (teams.public.length && teams.private.length)
      return `
        Open and private teams will receive this check-in:
        ${toSentenceHTML(teams.public)} ${toVerb(teams.public)} open, and
        ${toSentenceHTML(teams.private)} ${toVerb(teams.private)} private.
      `
    if (!teams.public.length && teams.private.length > 1)
      return `
        Multiple private teams will receive this check-in:
        ${toSentenceHTML(teams.private)}.
      `
    return `
        ${toSentenceHTML(teams)} will receive this check-in.
      `
  }

  get teams() {
    const teams = Object.assign([], { public: [], private: [] })
    for (const option of this.multiselectTarget.selectedOptions) {
      const { label, visibility } = option.dataset
      teams.push(label), teams[visibility].push(label)
    }
    return teams
  }
}

function toSentenceHTML(words, tagName = "strong") {
  return toSentence(words.map((word) => toHTML(word, tagName)))
}

function toHTML(textContent, tagName) {
  return createElement(tagName, { textContent }).outerHTML
}

function toVerb({ length }) {
  return length > 1 ? "are" : "is"
}
